import { groupByDictUnique } from '../../common/utils';
import { Expansion, ExpansionLevelCap, ExpansionPatch } from '../expansion';
import { Difficulty, FeatureFlag, RaidDifficulty, UserConnectionType, WoWDifficultyId } from '../sharedTypes';
import { RAID_METADATA } from './raids';
import { WOW_CLASSIC_ROUTES } from './routes';
import { IClassicGameConfig } from './types';
import { SEASONS, SEASONS_BY_SLUG } from './mythicPlus';
import { generateGetSeasonBySlug, getSeasonByEventId, getSortedSeasons } from '../mythicPlus';
import { WOWCLASSIC_EVENT_CONFIG } from './events';
import { QUALIFIED_GUILD_RECRUITMENT_TAGS } from './qualifiedGuildRecruitmentTags';

const RAID_DIFFICULTIES: Difficulty[] = [
  {
    id: WoWDifficultyId.NORMAL_RAID,
    slug: RaidDifficulty.NORMAL,
    name: 'Flexible',
    acronym: 'FLEX',
    maxMembers: 30
  },
  {
    id: WoWDifficultyId.NORMAL_10,
    slug: RaidDifficulty.NORMAL_10,
    name: 'Normal 10',
    acronym: 'N10',
    maxMembers: 10
  },
  {
    id: WoWDifficultyId.NORMAL_25,
    slug: RaidDifficulty.NORMAL_25,
    name: 'Normal 25',
    acronym: 'N25',
    maxMembers: 25
  },
  {
    id: WoWDifficultyId.HEROIC_10,
    slug: RaidDifficulty.HEROIC_10,
    name: 'Heroic 10',
    acronym: 'H10',
    maxMembers: 10
  },
  {
    id: WoWDifficultyId.HEROIC_25,
    slug: RaidDifficulty.HEROIC_25,
    name: 'Heroic 25',
    acronym: 'H25',
    maxMembers: 25
  }
];

const config: IClassicGameConfig = {
  SiteBackdropPath: '/images/site/classic_mists_backdrop.png',

  //
  // Expansion Settings
  //
  CurrentExpansion: Expansion.MistsOfPandaria,
  NextExpansion: Expansion.MistsOfPandaria,
  PreviousExpansion: Expansion.Cataclysm,
  FirstSupportedExpansion: Expansion.WrathOfTheLichKing,

  //
  // Patch Settings
  //
  CurrentPatch: ExpansionPatch.Patch_540,
  FirstSupportedPatch: ExpansionPatch.Patch_300,
  PublicTestRealmPatch: ExpansionPatch.Patch_400,
  BetaPatch: ExpansionPatch.Patch_500,

  CurrentLevelCap: ExpansionLevelCap.MistsOfPandaria,
  PreviousLevelCap: ExpansionLevelCap.Cataclysm,
  MinScanLevel: 10,

  RaidDifficulties: RAID_DIFFICULTIES,

  Raids: RAID_METADATA,
  RaidsBySlug: groupByDictUnique(RAID_METADATA, 'slug'),

  MythicPlusSeasons: SEASONS,
  MythicPlusSeasonsSorted: getSortedSeasons(SEASONS),
  MythicPlusSeasonsByPartitionEventId: getSeasonByEventId(SEASONS),
  MythicPlusSeasonsBySlug: SEASONS_BY_SLUG,

  getSeasonBySlug: generateGetSeasonBySlug([], {}),

  Routes: WOW_CLASSIC_ROUTES,

  Expansions: [],
  getExpansionById: () => {
    throw new Error('Not implemented');
  },

  getExpansionBySlug: () => {
    throw new Error('Not implemented');
  },

  BaselineFeatures: [
    FeatureFlag.AC_QUEUE,
    FeatureFlag.AC_DOCKING,
    FeatureFlag.AC_DOCKING_CHARACTER,
    FeatureFlag.AC_DOCKING_GUILD,
    // FeatureFlag.RECRUITMENT,
    // FeatureFlag.RECRUITMENT_VIEW,
    // FeatureFlag.RECRUITMENT_SEARCH,
    // FeatureFlag.RECRUITMENT_CREATE,
    FeatureFlag.MESSAGE_CENTER,
    FeatureFlag.MANAGE_RAID_ENCOUNTER_VIDEOS,
    FeatureFlag.MANAGE_KEYSTONE_RUN_VIDEOS
  ],

  UserConnectionTypes: [
    UserConnectionType.DISCORD,
    UserConnectionType.TWITCH,
    UserConnectionType.YOUTUBE,
    UserConnectionType.DOUYU
  ],

  ItemSlotGroups: [
    ['head'],
    ['neck'],
    ['shoulder'],
    ['back'],
    ['chest'],
    ['shirt'], // classic
    ['wrist'],
    ['hands'],
    ['waist'],
    ['legs'],
    ['feet'],
    ['finger1'],
    ['finger2'],
    ['trinket1', 'trinket2'],
    ['mainhand'],
    ['offhand'],
    ['ranged'] // classic
  ],

  EventConfig: WOWCLASSIC_EVENT_CONFIG,

  QualifiedGuildRecruitmentTags: QUALIFIED_GUILD_RECRUITMENT_TAGS
};

export default config;
